<template>
  <div class="cp__loader__container loader">
    <img width="80px" height="80px" alt="Processing..." :src="processingGIF" @error="require('@/assets/images/loader.svg')" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ProcessingLoader',
  computed: {
    ...mapGetters(['processingGIF'])
  }
}
</script>

<style scoped>

</style>
